module.exports = __webpack_public_path__ + "img/feeds.27af78a4.jpg";